import React, { useState, useEffect } from 'react';
import { apiRaw } from '../../api';
import { logCliente } from '../../utils/logCliente';
import { pedirNotaCancelacion, avisoEncuestaIncompleta, mensajeComentarioGuardado, mensajeReprogramada, mensajeCancelarLote } from '../../utils/citas';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/es'; // Importar el locale de español
import 'react-big-calendar/lib/css/react-big-calendar.css'; // Importar el estilo
import Modal from 'react-modal';
import './Citas.css';
import Swal, { avisoExito, avisoFalta, avisoError } from '../../utils/swal';
import * as XLSX from 'xlsx';
import { puedeExportar } from '../../Helpers/rolesPermisos';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye, faTriangleExclamation, faUmbrellaBeach } from '@fortawesome/free-solid-svg-icons';
import { fetchUsuario, getUsuario } from '../user';
import Select from 'react-select';
import baseURL from '../url';
import { tz } from 'dayjs';
import Helper from '../../Helpers/helpers';
import AsyncSelect from 'react-select/async';

import TurnoModal from '../Modals/TurnoModal';
import enviarPdfAlServidor from '../Dias/DescargarCitaPdf';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

// Configurar moment.js para usar el idioma español
moment.locale('es'); // Establecer el idioma a español
const localizer = momentLocalizer(moment);

// Mensajes en español para las vistas
const messages = {
    today: 'Hoy',
    previous: 'Anterior',
    next: 'Siguiente',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    agenda: 'Agenda',
    date: 'Fecha',
    time: 'Hora',
    event: 'Evento',
    noEventsInRange: (
        <div style={{ textAlign: 'center', padding: '2.5rem 1rem', color: '#8a8a8a' }}>
            <FontAwesomeIcon icon={faUmbrellaBeach} style={{ fontSize: '2.5rem', color: '#14a7a3', marginBottom: '0.75rem' }} />
            <div style={{ fontSize: '1.05rem', fontWeight: 600, color: '#555' }}>¡No hay citas en este rango!</div>
        </div>
    ),
};

export default function Citas() {
    const color1 = getComputedStyle(document.documentElement).getPropertyValue('--color1');
    const [turnos, setTurnos] = useState([]);
    const [turnoSeleccionado, setTurnoSeleccionado] = useState(null); // Estado para el turno seleccionado
    const [modalIsOpen, setModalIsOpen] = useState(false); // Estado para abrir o cerrar el modal

    // Determinar el rol del usuario para aplicar restricciones
    const usuarioLegued = getUsuario();
    const esSecretaria = usuarioLegued?.rol === 'secretaria';

    const [nombre, setNombre] = useState("");
    const [telefono, setTelefono] = useState("");
    const [motivoInactivo, setMotivoInactivo] = useState([]);

    const [nuevaFecha, setNuevaFecha] = useState("");
    const [periodicidad, setPeriodicidad] = useState("");

    const [nuevaHoraInicio, setNuevaHoraInicio] = useState("");
    const [nuevaHoraFin, setNuevaHoraFin] = useState("");

    const [nuevoComentario, setNuevoComentario] = useState("");
    const [comentarioActualizado, setComentarioActualizado] = useState(0); //se usa para saber cuando se agrego un comentario
    const [cancelarActualizado, setCancelarActualizado] = useState(0); //se usa para saber cuando se hizo una cancelacion

    const [nuevoEstado, setNuevoEstado] = useState('');
    const [servicios, setServicios] = useState([]);
    const [servicioSeleccionado, setServicioSeleccionado] = useState(null); // Establecer el servicio seleccionado por defecto
    const [serviciosFiltrados, setServiciosFiltrados] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [selectedEstados, setSelectedEstados] = useState(['pendiente', 'asignado']); // Por default: Pendiente y Asignado
    const [terapeutas, setTerapeutas] = useState([]);
    const [terapeutaSeleccionado, setTerapeutaSeleccionado] = useState('');
    const [salas, setSalas] = useState([]);
    const [salaSeleccionada, setSalaSeleccionada] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('');

    const [citasSeleccionadas, setCitasSeleccionadas] = useState([]); //seleccionadas para cancelarse

    const [categoriasFiltradas, setCategoriasFiltradas] = useState([]);

    // Estados para catálogos sociodemográficos
    const [catalogoEscolaridad, setCatalogoEscolaridad] = useState([]);
    const [catalogoEstadoCivil, setCatalogoEstadoCivil] = useState([]);
    const [catalogoMotivosConsulta, setCatalogoMotivosConsulta] = useState([]);
    const [catalogoMunicipios, setCatalogoMunicipios] = useState([]);
    const [catalogoReligiones, setCatalogoReligiones] = useState([]);
    const [catalogoServiciosSalud, setCatalogoServiciosSalud] = useState([]);
    const [catalogoSexo, setCatalogoSexo] = useState([]);
    const [catalogoComoEntero, setCatalogoComoEntero] = useState([]);
    const [comoEntero, setComoEntero] = useState("");

    const [escolaridad, setEscolaridad] = useState("");
    const [estadoCivil, setEstadoCivil] = useState("");
    const [motivoConsulta, setMotivoConsulta] = useState("");
    const [municipio, setMunicipio] = useState("");
    const [religion, setReligion] = useState("");
    const [servicioSalud, setServicioSalud] = useState("");
    const [sexo, setSexo] = useState("");
    const [ocupacion, setOcupacion] = useState("");


    useEffect(() => {
        cargarTurnos();
        cargarServicios();
        cargarUsuarios();
        cargarSalas();
        cargarCategorias();
        cargarCatalogos();
    }, []);
    //Trae usuario logueado-----------------------------
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    // La encuesta sociodemográfica se llena en blanco cada vez que se abre una cita distinta (nunca se precargan valores).
    useEffect(() => {
        setEscolaridad("");
        setEstadoCivil("");
        setMotivoConsulta("");
        setMunicipio("");
        setReligion("");
        setServicioSalud("");
        setSexo("");
        setOcupacion("");
    }, [turnoSeleccionado?.idTurno]);

    // Establecer Ceseco principal por defecto cuando hay filtro disponible (admin, direccion)
    useEffect(() => {
        if (categorias.length > 0 && usuarioLegued && categoriasFiltradas.length === 0) {
            if ((usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion')) {
                const cesecoPrincipal = usuarioLegued.cesecoPrincipal || 
                                       usuarioLegued.categorias?.find(c => c.esPrincipal === 1 || c.esPrincipal === '1') ||
                                       (usuarioLegued.idCategoria && categorias.find(c => c.idCategoria === usuarioLegued.idCategoria));
                
                if (cesecoPrincipal) {
                    const cesecoEnLista = categorias.find(c => 
                        c.idCategoria === cesecoPrincipal.idCategoria || c.idCategoria === cesecoPrincipal
                    );
                    
                    if (cesecoEnLista) {
                        setCategoriasFiltradas([{ value: cesecoEnLista.idCategoria, label: cesecoEnLista.categoria }]);
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categorias.length, usuarioLegued?.idCategoria, usuarioLegued?.cesecoPrincipal?.idCategoria]);

    // Establecer servicio principal por defecto cuando se carguen los servicios
    useEffect(() => {
        if (servicios.length > 0 && usuarioLegued && serviciosFiltrados.length === 0) {
            // Buscar el servicio principal del usuario
            const servicioPrincipal = usuarioLegued.servicioPrincipal || 
                                     usuarioLegued.servicios?.find(s => s.esPrincipal === 1 || s.esPrincipal === '1') ||
                                     (usuarioLegued.idServicio && servicios.find(s => s.idServicio === usuarioLegued.idServicio));
            
            if (servicioPrincipal) {
                const servicioEnLista = servicios.find(s => {
                    // Si hay Cesecos filtrados, verificar que el servicio pertenezca a uno de ellos
                    if (categoriasFiltradas.length > 0) {
                        const perteneceACesecoFiltrado = categoriasFiltradas.some(c => c.value === s.idCategoria);
                        if (!perteneceACesecoFiltrado) return false;
                    } else {
                        // Verificar que el servicio pertenezca a uno de los Cesecos asignados
                        const perteneceACeseco = usuarioLegued?.idCategorias?.includes(s.idCategoria) ||
                                                s.idCategoria === usuarioLegued.idCategoria;
                        if (!perteneceACeseco) return false;
                    }
                    
                    // Para coord_ceseco y secretaria: todos los servicios de sus Cesecos
                    if (usuarioLegued?.rol === 'coord_ceseco' || usuarioLegued?.rol === 'secretaria') {
                        return s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal;
                    }
                    
                    // Para coord_programa: solo servicios asignados directamente
                    if (usuarioLegued?.rol === 'coord_programa') {
                        return (s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal) &&
                               (usuarioLegued?.idServicios?.includes(s.idServicio) || usuarioLegued?.idServicio === s.idServicio);
                    }
                    
                    return s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal;
                });
                
                if (servicioEnLista) {
                    setServiciosFiltrados([{ value: servicioEnLista.idServicio, label: servicioEnLista.titulo }]);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [servicios.length, usuarioLegued?.idServicio, usuarioLegued?.servicioPrincipal?.idServicio, categoriasFiltradas.length]);

    const cargarTurnos = () => {
        return apiRaw(`/turnos`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const turnosConDias = data.turnos?.map(turno => ({
                    ...turno,
                    dias: JSON.parse(turno.dias)
                })) || [];

                setTurnos(turnosConDias);
                return turnosConDias;
            })
            .catch(error => {
                console.error('Error al cargar turnos:', error);
                return [];
            });
    };

    const cargarServicios = () => {
        apiRaw(`/servicios`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setServicios(data.servicios || []);
                if (data.servicios && data.servicios.length > 0) {
                    setServicioSeleccionado(data.servicios[0].idServicio); // Selecciona el primer servicio por defecto
                }
            })
            .catch(error => console.error('Error al cargar servicios:', error));
    };

    const cargarUsuarios = () => {
        apiRaw(`/usuarios`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTerapeutas(data.usuarios.filter(usuario => (usuario.rol === "terapeuta")) || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarSalas = () => {
        apiRaw(`/salas`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSalas(data.salas || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarCategorias = () => {
        apiRaw(`/categorias`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const categoriasOrdenadas = (data?.categorias || [])?.sort((a, b) => a.orden - b.orden);
                setCategorias(categoriasOrdenadas);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarCatalogos = () => {

        //ESCOLARIDAD
        apiRaw(`/catalogos/escolaridad`, { method: 'GET', }).then(response => response.json())
            .then(data => {
                setCatalogoEscolaridad(data.catalogo);
            }).catch(error => console.error('Error al cargar el catálogo escolaridad:', error));

        //ESTADO CIVIL    
        apiRaw(`/catalogos/estado_civil`, { method: 'GET', }).then(response => response.json())
            .then(data => {
                setCatalogoEstadoCivil(data.catalogo);
            }).catch(error => console.error('Error al cargar el catálogo estado civil:', error));

        //MOTIVOS DE CONSULTA    
        apiRaw(`/catalogos/motivos_de_consulta`, { method: 'GET', }).then(response => response.json())
            .then(data => {
                setCatalogoMotivosConsulta(data.catalogo);
            }).catch(error => console.error('Error al cargar el catálogo motivos de consulta:', error));

        //MUNICIPIOS    
        apiRaw(`/catalogos/municipios`, { method: 'GET', }).then(response => response.json())
            .then(data => {
                setCatalogoMunicipios(data.catalogo);
            }).catch(error => console.error('Error al cargar el catálogo municipios:', error));

        //RELIGIONES    
        apiRaw(`/catalogos/religiones`, { method: 'GET', }).then(response => response.json())
            .then(data => {
                setCatalogoReligiones(data.catalogo);
            }).catch(error => console.error('Error al cargar el catálogo religiones:', error));

        //SERVICIOS DE SALUD   
        apiRaw(`/catalogos/servicios_de_salud`, { method: 'GET', }).then(response => response.json())
            .then(data => {
                setCatalogoServiciosSalud(data.catalogo);
            }).catch(error => console.error('Error al cargar el catálogo servicios de salud:', error));

        //SEXO   
        apiRaw(`/catalogos/sexo`, { method: 'GET', }).then(response => response.json())
            .then(data => {
                setCatalogoSexo(data.catalogo);
            }).catch(error => console.error('Error al cargar el catálogo sexo:', error));

        apiRaw(`/catalogos/como_entero`)
            .then(res => res.json())
            .then(data => setCatalogoComoEntero(data.catalogo || []))
            .catch(error => console.error('Error al cargar el catálogo como entero:', error));

    };

    const handleSelectEvent = (event) => {
        // Filtrar el turno seleccionado por su idTurno
        const turnoSeleccionado = turnos.find(item => item.idTurno === event.idTurno);

        if (turnoSeleccionado) {
            setTurnoSeleccionado(turnoSeleccionado); // Establecer el turno seleccionado
            setModalIsOpen(true); // Abrir el modal (el recordatorio de la encuesta, si falta, lo muestra el propio modal)
            setTerapeutaSeleccionado(turnoSeleccionado.idTerapeuta);
            setSalaSeleccionada(turnoSeleccionado.idSala);
        }
    };

    const handleCloseModal = () => {
        setModalIsOpen(false); // Cerrar el modal
    };

    const guardarInfoPaciente = () => {
        // Diagnóstico (ver utils/logCliente): sólo qué pasó, nunca qué se contestó.
        const ctx = { idTurno: turnoSeleccionado?.idTurno, idPaciente: turnoSeleccionado?.idPaciente ?? null };
        logCliente('encuesta.guardar', ctx);
        const faltante = [['sexo', sexo], ['escolaridad', escolaridad], ['estadoCivil', estadoCivil], ['ocupacion', ocupacion],
            ['servicioSalud', servicioSalud], ['religion', religion], ['municipio', municipio], ['motivoConsulta', motivoConsulta]]
            .find(([, v]) => v == '');
        if (faltante) logCliente('encuesta.validacion', { ...ctx, campo: faltante[0] });
        if (sexo == '') {
            Swal.fire('Alerta!', 'Debes seleccionar una opción en sexo', 'warning');
        } else if (escolaridad == '') {
            Swal.fire('Alerta!', 'Debes seleccionar una opción en escolaridad', 'warning');
        } else if (estadoCivil == '') {
            Swal.fire('Alerta!', 'Debes seleccionar una opción en estado civil', 'warning');
        } else if (ocupacion == '') {
            Swal.fire('Alerta!', 'Debes escribir una ocupación', 'warning');
        } else if (servicioSalud == '') {
            Swal.fire('Alerta!', 'Debes seleccionar una opción en acceso a servicios de salud', 'warning');
        } else if (religion == '') {
            Swal.fire('Alerta!', 'Debes seleccionar una opción en religión', 'warning');
        } else if (municipio == '') {
            Swal.fire('Alerta!', 'Debes seleccionar una opción en municipio', 'warning');
        } else if (motivoConsulta == '') {
            Swal.fire('Alerta!', 'Debes seleccionar una opción en motivo de consulta', 'warning');
        } else {

            if (turnoSeleccionado.idPaciente != null) {

                const payload = {
                    sexo,
                    escolaridad,
                    estadoCivil,
                    ocupacion,
                    servicioSalud,
                    religion,
                    municipio,
                    motivoConsulta,
                    idPaciente: turnoSeleccionado.idPaciente,
                    comoEntero
                };

                logCliente('encuesta.envio', { ...ctx, metodo: 'PUT' });
                apiRaw(`/pacientes/${turnoSeleccionado.idPaciente}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                }).then(response => {
                    if (!response.ok) {
                        const e = new Error('La solicitud no fue exitosa');
                        e.status = response.status;
                        throw e;
                    }
                    return response.json();
                })
                    .then(data => {
                        if (data.error) {
                            logCliente('encuesta.error', { ...ctx, mensaje: String(data.error).slice(0, 200) });
                            avisoError(data.error);
                        } else {
                            logCliente('encuesta.ok', ctx);
                            avisoExito('Datos del paciente guardados');
                            cargarTurnos().then(nuevos => {
                                const actualizado = nuevos.find(t => t.idTurno === turnoSeleccionado.idTurno);
                                if (actualizado) setTurnoSeleccionado({ ...actualizado });
                            });
                        }
                    })
                    .catch(error => {
                        logCliente('encuesta.error', { ...ctx, status: error.status ?? null, mensaje: String(error.message).slice(0, 200) });
                        avisoError('No se pudieron guardar los datos del paciente. Intenta de nuevo.');
                    });

            } else {

                const formData = new FormData();

                formData.append('sexo', sexo);
                formData.append('escolaridad', escolaridad);
                formData.append('estadoCivil', estadoCivil);
                formData.append('ocupacion', ocupacion);
                formData.append('servicioSalud', servicioSalud);
                formData.append('religion', religion);
                formData.append('municipio', municipio);
                formData.append('motivoConsulta', motivoConsulta);
                formData.append('nombrePaciente', turnoSeleccionado.nombre);
                formData.append('idTurno', turnoSeleccionado.idTurno);
                formData.append('comoEntero', comoEntero);

                logCliente('encuesta.envio', { ...ctx, metodo: 'POST' });
                apiRaw(`/pacientes`, {
                    method: 'POST',
                    body: formData
                }).then(response => {
                    if (!response.ok) {
                        const e = new Error('La solicitud no fue exitosa');
                        e.status = response.status;
                        throw e;
                    }
                    return response.json();
                })
                    .then(data => {
                        if (data.error) {
                            logCliente('encuesta.error', { ...ctx, mensaje: String(data.error).slice(0, 200) });
                            avisoError(data.error);
                        } else {
                            logCliente('encuesta.ok', ctx);
                            avisoExito('Datos del paciente guardados');
                            cargarTurnos().then(nuevos => {
                                const actualizado = nuevos.find(t => t.idTurno === turnoSeleccionado.idTurno);
                                if (actualizado) setTurnoSeleccionado({ ...actualizado });
                            });
                        }
                    })
                    .catch(error => {
                        logCliente('encuesta.error', { ...ctx, status: error.status ?? null, mensaje: String(error.message).slice(0, 200) });
                        avisoError('No se pudieron guardar los datos del paciente. Intenta de nuevo.');
                    });
            }
        }
    };

    // const handleSelectSlot = (slotInfo) => {
    //     // Mostrar un mensaje cuando se selecciona un rango de fechas
    //     alert(`Seleccionado el rango: ${slotInfo.start} - ${slotInfo.end}`);
    // };

    // Inicialización de servicios del usuario logueado
    const serviciosUsuario = usuarioLegued?.rol === "admin"
        ? servicios
        : servicios.filter(servicio => servicio.idUsuario === usuarioLegued?.idUsuario);

    // Selección inicial del servicio
    const servicioSeleccionadoInicial = servicioSeleccionado || serviciosUsuario[0]?.idServicio;

    const handleFilterChange = (e) => {
        setFilterText(e.target.value.toLowerCase());
    };

    const filteredTurnos = Helper.filterTurnosByEstados({
        turnos: turnos?.filter(turno => {
            // Filtro por servicios seleccionados
            const pasaFiltroServicios = serviciosFiltrados.length === 0 || 
                serviciosFiltrados.map(servicio => servicio.value).includes(turno?.idServicio);
            
            // Filtro por categorías seleccionadas
            const pasaFiltroCategorias = categoriasFiltradas.length === 0 || 
                categoriasFiltradas.map(categoria => categoria.value).includes(turno?.idCategoriaSala);
            
            // Para coord_ceseco, coord_programa y secretaria: si no hay filtros, mostrar turnos de todos sus Cesecos asignados
            if ((usuarioLegued?.rol === 'coord_ceseco' || 
                 usuarioLegued?.rol === 'coord_programa' || 
                 usuarioLegued?.rol === 'secretaria') && 
                serviciosFiltrados.length === 0 && categoriasFiltradas.length === 0) {
                const tieneAcceso = usuarioLegued?.idCategorias?.includes(turno?.idCategoriaSala) ||
                                   turno?.idCategoriaSala === usuarioLegued?.idCategoria;
                return tieneAcceso;
            }
            
            return pasaFiltroServicios && pasaFiltroCategorias;
        }),
        selectedEstados,
        usuarioLegued,
        filterText,
        serviciosFiltrados: [] // ya filtrado arriba
    });

    const serviciosEnVista = [...new Set(
        (filteredTurnos || []).map(turno => turno?.servicio).filter(Boolean)
    )];

    // turnos?.filter(
    //     (turno) =>
    //         turno?.nombre?.toLowerCase()?.includes(filterText) ||
    //         turno?.dni?.includes(filterText) ||
    //         turno?.telefono?.includes(filterText)
    // );

    // En pantallas angostas "Mes" apenas cabe "+2 more" por día; "Agenda" (lista) se lee bien ahí.
    const [currentView, setCurrentView] = useState(() => (window.innerWidth < 1024 ? 'agenda' : 'month'));
    // En móvil los filtros (buscador, Cesecos, Servicios, estado) arrancan ocultos para que la
    // primera cita se vea sin bajar ~700px; en escritorio siguen visibles como siempre.
    const [filtrosAbiertos, setFiltrosAbiertos] = useState(() => window.innerWidth >= 1024);

    const CustomEvent = ({ event }) => {
        const horaInicio = moment(event.start).format('HH:mm');
        const horaFin = moment(event.end).format('HH:mm');
        const color = event.style?.color || 'black';
        const nombre = event.title?.split(' - ')[0] ?? event.title;

        if (currentView === 'month') {
            return (
                <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: '0.78em', color }}>
                    {nombre}
                </div>
            );
        }

        return (
            <div style={{ whiteSpace: 'normal', color }}>
                <div style={{ fontSize: '0.8em' }}>{horaInicio} - {horaFin}</div>
                <div style={{ fontSize: '0.8em' }}><strong>{event.title}</strong></div>
            </div>
        );
    };

    // Filtro de turnos ajustado para admin y colaborador
    const events = filteredTurnos
        // ?.filter(item => {
        //     if (!usuarioLegued || !usuarioLegued.idUsuario) {
        //         // Sin usuario logueado: mostrar todos los turnos
        //         return servicioSeleccionado ? item.idServicio === servicioSeleccionado : true;
        //     }

        //     if (usuarioLegued.rol === "admin") {
        //         // Si es admin: mostrar todos los turnos y los del servicio seleccionado
        //         return servicioSeleccionado ? item.idServicio === servicioSeleccionado : true;
        //     }

        //     if (usuarioLegued.rol !== "admin") {
        //         // Si es colaborador: mostrar solo los turnos vinculados a sus servicios
        //         const serviciosFiltrados = serviciosUsuario.map(s => s.idServicio);
        //         return serviciosFiltrados.includes(item.idServicio) &&
        //             item.idServicio === servicioSeleccionadoInicial;
        //     }


        //     return false; // Fallback de seguridad
        // })
        .map(item => {
            const dias = item.dias ?? [];
            return dias?.map(dia => {
                const colors = Helper.getTurnoColors(item);

                return {
                    title: `${item.nombre} - ${item.servicio}`,
                    start: new Date(dia.dia + "T" + dia.horaInicio),
                    end: new Date(dia.dia + "T" + dia.horaFin),
                    allDay: false,
                    idTurno: item.idTurno,
                    estado: item.estado,
                    style: { backgroundColor: colors[0], color: colors[1] },
                };
            });
        })
        .flat() ?? [];

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoEstado(turnoSeleccionado?.estado);
    }, [turnoSeleccionado]);

    const handleUpdateText = async (idTurno) => {

        // Pasar la cita a Inactivo es cancelarla: obliga a dejar una nota, que queda en Comentarios (línea de tiempo).
        let nota = null;
        if (nuevoEstado == 'Inactivo' && turnoSeleccionado.estado !== 'Inactivo') {
            if (await avisoEncuestaIncompleta(turnoSeleccionado, avisoFalta)) return;
            nota = await pedirNotaCancelacion(Swal);
            if (!nota) return;
        }


        if (nuevoEstado == 'Asignado') {
            //crear pdf
            const detallesTurno = {
                idTurno: idTurno,
                servicio: turnoSeleccionado.servicio,
                dia: dayjs(turnoSeleccionado.dias[0].dia).format('dddd'),
                fecha: dayjs(turnoSeleccionado.dias[0].dia).format('dddd, D [de] MMMM [de] YYYY'),
                horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                horarioFin: turnoSeleccionado.dias[0].horaFin,
                nombre,
                telefono,
                categoria: turnoSeleccionado.nombreCategoria,
                ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
            };
            enviarPdfAlServidor(detallesTurno);
        }


        try {

            const payload = {
                idTurno: idTurno,
                nombre: nombre,
                telefono: telefono,
                idServicio: Number(servicioSeleccionado),
                idTerapeuta: terapeutaSeleccionado ? terapeutaSeleccionado : null,
                idSala: salaSeleccionada ? salaSeleccionada : null,
                estado: nuevoEstado !== '' ? nuevoEstado : turnoSeleccionado.estado,
                motivo_inactivo: motivoInactivo != '' ? motivoInactivo : null,
                nota
            };


            apiRaw(`/turnos/${idTurno}/asignar`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then(response => response.json())
                .then(async (data) => {
                    if (data.error) {
                        avisoError(data.error);
                    } else {

                        avisoExito(data.mensaje);
                        const nuevosTurnos = await cargarTurnos();
                        const turnoSeleccionado = nuevosTurnos.find(item => item.idTurno === idTurno);
                        setTurnoSeleccionado({ ...turnoSeleccionado });
                    }
                })
                .catch(() => {
                    avisoError('No se pudo asignar la cita. Intenta de nuevo.');
                });
        } catch (error) {
            avisoError('No se pudo asignar la cita. Intenta de nuevo.');
        }
    };

    const handleUpdateDate = async (idTurno) => {
        try {

            const payload = {
                idTurno: idTurno,
                nuevaFecha: nuevaFecha,
                periodicidad: periodicidad,
                nuevaHoraInicio: nuevaHoraInicio,
                nuevaHoraFin: nuevaHoraFin
            };

            apiRaw(`/turnos/${idTurno}/reprogramar`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then(response => response.json())
                .then(async (data) => {
                    if (data.error) {
                        avisoError(data.error);
                    } else {
                        avisoExito(mensajeReprogramada(nuevaFecha, nuevaHoraInicio));
                        const nuevosTurnos = await cargarTurnos();
                        const turnoSeleccionado = nuevosTurnos.find(item => item.idTurno === idTurno);
                        setTurnoSeleccionado({ ...turnoSeleccionado });
                    }
                })
                .catch(() => {
                    avisoError('No se pudo reprogramar la cita. Intenta de nuevo.');
                });
        } catch (error) {
            avisoError('No se pudo reprogramar la cita. Intenta de nuevo.');
        }
    };

    const handleInsertComment = async (idTurno, tipo, opciones = {}) => {
        if (tipo === 3 && nuevoEstado != 'Asignado') {
            avisoError('Para poder programar citas el estado de la cita debe ser Asignado');
        } else {
            try {

                const formData = new FormData();
                formData.append('idTurno', idTurno);
                formData.append('idTerapeuta', usuarioLegued.idUsuario);
                formData.append('comentario', nuevoComentario);
                formData.append('tipo_de_comentario', tipo);
                formData.append('periodicidad', periodicidad);

                if (opciones.fecha) {
                    formData.append('nuevaFecha', opciones.fecha);
                }
                if (opciones.horaInicio) {
                    formData.append('nuevaHoraInicio', opciones.horaInicio);
                }
                if (opciones.horaFin) {
                    formData.append('nuevaHoraFin', opciones.horaFin);
                }
                if (opciones.idSala) {
                    formData.append('idSala', opciones.idSala);
                }

                apiRaw(`/comentarios`, {
                    method: 'POST',
                    body: formData,
                })
                    .then(response => response.json())
                    .then(async (data) => {
                        if (data.error) {
                            avisoError(data.error);
                        } else {
                            let nCitasAgendadas = tipo === 4 ? 1 : 0;
                            if (tipo === 4) {
                                //creamos el pdf
                                const idTurnoNuevo = Number(data.turno);
                                const nuevaFecha = data.fecha;

                                const detallesTurno = {
                                    idTurno: idTurnoNuevo,
                                    servicio: turnoSeleccionado.servicio,
                                    dia: dayjs(nuevaFecha).format('dddd'),
                                    fecha: dayjs(nuevaFecha).format('dddd, D [de] MMMM [de] YYYY'),
                                    horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                                    horarioFin: turnoSeleccionado.dias[0].horaFin,
                                    nombre: turnoSeleccionado.nombre,
                                    telefono: turnoSeleccionado.telefono,
                                    categoria: turnoSeleccionado.nombreCategoria,
                                    ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
                                };
                                enviarPdfAlServidor(detallesTurno);
                            }
                            if (tipo === 3) {
                                //creamos los pdfs
                                const idsTurnosNuevos = data.turnos;
                                const nuevasFechas = data.fechas;
                                nCitasAgendadas = idsTurnosNuevos.length;

                                idsTurnosNuevos.forEach((idTurnoNuevo, index) => {
                                    const nuevaFecha = nuevasFechas[index];

                                    const detallesTurno = {
                                        idTurno: Number(idTurnoNuevo),
                                        servicio: turnoSeleccionado.servicio,
                                        dia: dayjs(nuevaFecha).format('dddd'),
                                        fecha: dayjs(nuevaFecha).format('dddd, D [de] MMMM [de] YYYY'),
                                        horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                                        horarioFin: turnoSeleccionado.dias[0].horaFin,
                                        nombre: turnoSeleccionado.nombre,
                                        telefono: turnoSeleccionado.telefono,
                                        categoria: turnoSeleccionado.nombreCategoria,
                                        ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
                                    };

                                    enviarPdfAlServidor(detallesTurno);
                                });
                            }

                            avisoExito(mensajeComentarioGuardado(tipo, nCitasAgendadas));
                            const nuevosTurnos = await cargarTurnos();
                            const turnoSeleccionadoNuevo = nuevosTurnos.find(item => item.idTurno === idTurno);
                            setTurnoSeleccionado({ ...turnoSeleccionadoNuevo });
                            setComentarioActualizado((prev) => prev + 1);
                        }
                    })
                    .catch(() => {
                        avisoError('No se pudo guardar el comentario. Intenta de nuevo.');
                    });
            } catch (error) {
                avisoError('No se pudo guardar el comentario. Intenta de nuevo.');
            }
        }
    };

    const handleCancelar = async () => {
        if (citasSeleccionadas.length > 0) {
            // Si al paciente le falta la encuesta, el backend va a rechazar el lote completo (ver más abajo):
            // avisar antes de pedir la nota, para no hacer escribir una nota que de todos modos se va a rechazar.
            if (await avisoEncuestaIncompleta(turnoSeleccionado, avisoFalta)) return;

            // Cancelar obliga a dejar una nota: el servidor la guarda en Comentarios, en la línea de tiempo de cada cita.
            const nota = await pedirNotaCancelacion(Swal);
            if (!nota) return;

            try {

                const payload = {
                    turnos: citasSeleccionadas,
                    nota
                };

                apiRaw(`/turnos/cancelar-lote`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })

                    .then(response => response.json())
                    .then(async (data) => {
                        if (data.error) {
                            avisoError(data.error);
                        } else {
                            // El backend responde 200 aunque no haya cancelado nada (ej. encuesta incompleta):
                            // "canceladas" dice la verdad, no basta con la ausencia de "error".
                            const mensaje = mensajeCancelarLote(data.canceladas, data.bloqueadas);
                            if (data.canceladas === 0) {
                                avisoFalta(mensaje);
                            } else {
                                avisoExito(mensaje);
                            }
                            const nuevosTurnos = await cargarTurnos();
                            const turnoSeleccionadoNuevo = nuevosTurnos.find(item => item.idTurno === turnoSeleccionado.idTurno);
                            setTurnoSeleccionado({ ...turnoSeleccionadoNuevo });

                            setCancelarActualizado((prev) => prev + 1);
                        }
                    })
                    .catch(() => {
                        avisoError('No se pudo cancelar la cita. Intenta de nuevo.');
                    });
            } catch (error) {
                avisoError('No se pudo cancelar la cita. Intenta de nuevo.');
            }

        }

    };

    const handleSelectServicio = (idServicio) => {
        setServicioSeleccionado(idServicio); // Establece el servicio seleccionado
    };

    const handleSelecetTab = (tab) => {
        setSelectedEstados(tab);
    }

    const exportarExcel = () => {
        const turnosFiltrados = filteredTurnos.filter(item => !servicioSeleccionado || item.idServicio === servicioSeleccionado);

        const datos = turnosFiltrados.map(turno => ({
            Nombre: turno.nombre,
            DNI: turno.dni,
            Email: turno.email,
            Teléfono: turno.telefono,
            Estado: turno.estado,
            Días: turno.dias.map(dia => `${dia.dia} (${dia.horaInicio} - ${dia.horaFin})`).join(', ')
        }));

        const ws = XLSX.utils.json_to_sheet(datos);


        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Turnos");
        XLSX.writeFile(wb, `Turnos.xlsx`);
    };

    const exportarPDF = () => {
        const turnosFiltrados = filteredTurnos.filter(item => !servicioSeleccionado || item.idServicio === servicioSeleccionado);

        const doc = new jsPDF();

        const tableColumn = ["Nombre", "DNI", "Email", "Teléfono", "Estado", "Días"];
        const tableRows = turnosFiltrados.map(turno => [
            turno.nombre,
            turno.dni,
            turno.email,
            turno.telefono,
            turno.estado,
            turno.dias.map(dia => `${dia.dia} (${dia.horaInicio} - ${dia.horaFin})`).join(', ')
        ]);

        doc.text("Turnos del Servicio", 14, 15);
        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 20,
        });
        doc.save(`Turnos.pdf`);
    };

    // Estilos personalizados para los <Select/>
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? color1 : 'white',
            color: state.isSelected ? 'white' : 'black',
        }),
        control: (provided) => ({
            ...provided,
            maxHeight: '32px',
            overflowY: 'auto',
            paddingRight: '30px',
            borderRadius: '8px',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '8px',

        }),
        clearIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '20px',
            top: '2px',
            zIndex: 1,
            width: '50px',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '-5px',
            top: '2px',
            zIndex: 1,
        }),
    };

    const alertAsignarSala = (turno) => {

        Swal.fire({
            icon: 'question',
            html:
                `La cita para el día <strong>${moment(turno.dias[0].dia).format('DD/MM/YYYY')}</strong> de 
                <strong>${moment(`${turno.dias[0].dia} ${turno.dias[0].horaInicio}`).format('hh:mm a')} a 
                ${moment(`${turno.dias[0].dia} ${turno.dias[0].horaFin}`).format('hh:mm a')}</strong>
                será asignada al terapeuta 
                <strong>${terapeutas.filter(terapeuta => terapeuta.idUsuario == terapeutaSeleccionado)[0].nombre}</strong>
                y se impartirá en la sala 
                <strong>${salas.filter(sala => sala.idSala == salaSeleccionada)[0].nombre}</strong>
                <br><br>
                ¿Los datos son correctos?
                 `,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                'Aceptar',
            confirmButtonColor: '#14A7A3',
            cancelButtonText:
                'Modificar',
            preConfirm: () => {
                return {
                    idTurno: turno.idTurno,
                    idTerapeuta: terapeutaSeleccionado,
                }
            },
            preDeny: () => {
                return {
                    idTurno: turno.idTurno,
                }
            },
        })
            .then(async (result) => {

                if (result.isConfirmed) {
                    handleUpdateText(turnoSeleccionado.idTurno)
                }

            });
    };
    return (
        <div>
            <button
                type="button"
                className="filtros-toggle"
                onClick={() => setFiltrosAbiertos((v) => !v)}
            >
                Filtros {filtrosAbiertos ? '▲' : '▼'}
            </button>
            <div className={filtrosAbiertos ? '' : 'filtros-colapsables'}>
            {/* Leyenda de colores para los estatus de los turnos */}
            <div className="turnos-legend" style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#a0a0a0', border: '1px solid #888' }}></span>
                    <span>Pendiente</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#bee4fa', border: '1px solid #386def' }}></span>
                    <span>Asignado</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#e6f9ed', border: '1px solid #1a7f37' }}></span>
                    <span>Finalizado</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#fee9e9', border: '1px solid #ea4b29' }}></span>
                    <span>Inactivo</span>
                </div>
            </div>
            {/* Badge mostrando Ceseco y Programa asignados */}
            {(['admin', 'direccion', 'coord_ceseco', 'coord_programa', 'secretaria'].includes(usuarioLegued?.rol)) && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    padding: '0.5rem 0.75rem',
                    background: '#f8f9fa',
                    borderRadius: '6px',
                    border: '1px solid #e9ecef',
                    fontSize: '0.875rem',
                    color: '#495057',
                    marginBottom: '1rem',
                    maxWidth: 'fit-content',
                    flexWrap: 'wrap'
                }}>
                    <span style={{
                        fontSize: '0.875rem',
                        color: '#6c757d',
                        fontWeight: 500
                    }}>
                        Ceseco:
                    </span>
                    <span style={{
                        fontWeight: 600,
                        color: '#212529'
                    }}>
                        {usuarioLegued?.categorias && usuarioLegued.categorias.length > 0
                            ? usuarioLegued.categorias.map(c => c.categoria).join(', ')
                            : (usuarioLegued?.categoria || 
                               categorias.find(cat => cat.idCategoria === usuarioLegued?.idCategoria)?.categoria || 
                               'Sin asignar')}
                    </span>
                    <span style={{
                        fontSize: '0.875rem',
                        color: '#6c757d',
                        fontWeight: 500
                    }}>
                        Programa:
                    </span>
                    <span style={{
                        fontWeight: 600,
                        color: '#212529'
                    }}>
                        {serviciosFiltrados.length > 0
                            ? serviciosFiltrados.map(s => s.label).join(', ')
                            : (serviciosEnVista.length > 0
                                ? serviciosEnVista.join(', ')
                                : (usuarioLegued?.servicios && usuarioLegued.servicios.length > 0
                                    ? usuarioLegued.servicios.map(s => s.titulo).join(', ')
                                    : (usuarioLegued?.servicio || 
                                       servicios.find(s => s.idServicio === usuarioLegued?.idServicio)?.titulo || 
                                       'Sin asignar')))}
                    </span>
                </div>
            )}
            <div className='grapBtns'>
                {puedeExportar(usuarioLegued?.rol) && (
                    <>
                        <button onClick={exportarExcel} className="excel"> <FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                        <button onClick={exportarPDF} className="pdf"><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                    </>
                )}
                <div className='inputsColumn' style={{ minWidth: 420, maxWidth: 480 }}>
                    <AsyncSelect {...Helper.searchTurnosAsyncSelectConfig({ setTurnoSeleccionado, setModalIsOpen, baseURL, Helper, usuarioLegued })} />
                </div>
                {loading ? (
                    <></>
                ) : usuarioLegued?.idUsuario ? (
                    <>

                        {
                            (['admin', 'direccion', 'coord_ceseco', 'coord_programa', 'secretaria'].includes(usuarioLegued?.rol)) ? (
                                <>
                                    <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <Select
                                                isMulti
                                                options={
                                                    usuarioLegued?.rol === 'coord_programa'
                                                        ? // Para coord_programa: solo Cesecos de sus servicios asignados
                                                          (() => {
                                                              const serviciosAsignados = usuarioLegued?.idServicios || (usuarioLegued?.idServicio ? [usuarioLegued.idServicio] : []);
                                                              const cesecosDeServicios = servicios
                                                                  .filter(s => serviciosAsignados.includes(s.idServicio))
                                                                  .map(s => s.idCategoria);
                                                              const cesecosUnicos = [...new Set(cesecosDeServicios)];
                                                              return categorias
                                                                  .filter(c => cesecosUnicos.includes(c.idCategoria))
                                                                  .map(categoria => ({ value: categoria.idCategoria, label: categoria.categoria }));
                                                          })()
                                                        : // Para otros roles: todos los Cesecos
                                                          categorias.map(categoria => ({ value: categoria.idCategoria, label: categoria.categoria })) || []
                                                }
                                                value={categoriasFiltradas}
                                                onChange={(selectedOptions) => setCategoriasFiltradas(selectedOptions)}
                                                styles={customStyles}
                                                placeholder="Cesecos"
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <Select
                                                isMulti
                                                options={
                                                    usuarioLegued?.rol === 'coord_programa'
                                                        ? // Para coord_programa: solo sus servicios asignados
                                                          (() => {
                                                              const serviciosAsignados = usuarioLegued?.idServicios || (usuarioLegued?.idServicio ? [usuarioLegued.idServicio] : []);
                                                              return servicios
                                                                  .filter(s => serviciosAsignados.includes(s.idServicio))
                                                                  .map(servicio => ({ value: servicio.idServicio, label: servicio.titulo }));
                                                          })()
                                                        : // Para otros roles: filtrado por Ceseco seleccionado
                                                          (categoriasFiltradas && categoriasFiltradas.length > 0
                                                              ? servicios
                                                                  .filter(servicio => categoriasFiltradas.some(c => c.value === servicio.idCategoria))
                                                                  .map(servicio => ({ value: servicio.idServicio, label: servicio.titulo }))
                                                              : servicios.map(servicio => ({ value: servicio.idServicio, label: servicio.titulo })))
                                                }
                                                value={serviciosFiltrados}
                                                onChange={(selectedOptions) => setServiciosFiltrados(selectedOptions)}
                                                styles={customStyles}
                                                placeholder="Servicios"
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    </div>

                                    {
                                        (serviciosFiltrados.length > 0 || categoriasFiltradas.length > 0) &&
                                        <p onClick={() => { setServiciosFiltrados([]); setCategoriasFiltradas([]) }} style={{ color: '#6c757d', textDecoration: 'underline', textAlign: 'center', cursor: 'pointer' }}>Quitar Filtros</p>
                                    }

                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginLeft: '1rem', marginBottom: '1rem' }}>
                                        {Helper.estadoFiltros.map(filtro => (
                                            <button
                                                key={filtro.key}
                                                className={selectedEstados.includes(filtro.key) ? 'btnSelected' : 'btnNoSelected'}
                                                style={{
                                                    background: selectedEstados.includes(filtro.key) ? filtro.bg : '#f5f5f5',
                                                    color: selectedEstados.includes(filtro.key) ? filtro.color : '#333',
                                                    border: `1px solid ${filtro.border}`,
                                                    borderRadius: 8,
                                                    padding: '0.5rem 1.2rem',
                                                    fontWeight: 600,
                                                    boxShadow: selectedEstados.includes(filtro.key) ? `0 2px 8px ${filtro.bg}66` : 'none',
                                                    transition: 'all 0.2s',
                                                }}
                                                onClick={() => {
                                                    setSelectedEstados(prev =>
                                                        prev.includes(filtro.key)
                                                            ? prev.filter(e => e !== filtro.key)
                                                            : [...prev, filtro.key]
                                                    );
                                                }}
                                            >
                                                {filtro.label}
                                            </button>
                                        ))}
                                    </div>

                                </>
                            ) : (<></>)
                        }
                        
                        {/* {usuarioLegued?.rol === 'admin' ? (
                            <>
                                {
                                    servicios?.filter(item => usuarioLegued.rol === 'admin' || item.idUsuario === usuarioLegued.idUsuario).map(item => {
                                        const turnosPorServicio = turnos?.filter(turno => turno.idServicio === item.idServicio).length; // Calcular la cantidad de turnos para el servicio
                                        return (
                                            <button
                                                key={item.idServicio}
                                                className={servicioSeleccionado === item.idServicio ? 'btnSelected' : 'btnNoSelected'}
                                                onClick={() => handleSelectServicio(item.idServicio)}
                                            >
                                                ({turnosPorServicio})  <span>{item.titulo} </span>
                                            </button>
                                        );
                                    })
                                }
                            </>
                        ) : usuarioLegued?.rol === 'colaborador' ? (
                            <>
                                {
                                    servicios?.filter(item => usuarioLegued.rol === 'admin' || item.idUsuario === usuarioLegued.idUsuario).map(item => {
                                        const turnosPorServicio = turnos?.filter(turno => turno.idServicio === item.idServicio).length; // Calcular la cantidad de turnos para el servicio
                                        return (
                                            <button
                                                key={item.idServicio}
                                                className={servicioSeleccionado === item.idServicio ? 'btnSelected' : 'btnNoSelected'}
                                                onClick={() => handleSelectServicio(item.idServicio)}
                                            >
                                                ({turnosPorServicio})  <span>{item.titulo} </span>
                                            </button>
                                        );
                                    })
                                }
                            </>
                        ) : (
                            <></>
                        )} */}
                    </>
                ) : (
                    <>
                        {
                            servicios?.map(item => {
                                const turnosPorServicio = turnos?.filter(turno => turno.idServicio === item.idServicio).length; // Calcular la cantidad de turnos para el servicio
                                return (
                                    <button
                                        key={item.idServicio}
                                        className={servicioSeleccionado === item.idServicio ? 'btnSelected' : 'btnNoSelected'}
                                        onClick={() => handleSelectServicio(item.idServicio)}
                                    >
                                        ({turnosPorServicio})  <span>{item.titulo} </span>
                                    </button>
                                );
                            })
                        }
                    </>
                )}

            </div>
            </div>
            {/* Información de filtros activos */}
            {(categoriasFiltradas.length > 0 || serviciosFiltrados.length > 0) && (
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.75rem',
                    marginBottom: '1rem',
                    padding: '0.75rem 1rem',
                    background: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                }}>
                    {(['admin', 'direccion', 'coord_ceseco', 'coord_programa', 'secretaria'].includes(usuarioLegued?.rol) && categoriasFiltradas.length > 0) && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.5rem 0.75rem',
                            background: '#e7f3ff',
                            borderRadius: '6px',
                            fontSize: '0.875rem'
                        }}>
                            <span style={{ fontWeight: 600, color: '#0066cc' }}>Cesecos:</span>
                            <span style={{ color: '#333' }}>{categoriasFiltradas.map(obj => obj.label).join(', ')}</span>
                        </div>
                    )}
                    {serviciosFiltrados.length > 0 && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.5rem 0.75rem',
                            background: '#fff3cd',
                            borderRadius: '6px',
                            fontSize: '0.875rem'
                        }}>
                            <span style={{ fontWeight: 600, color: '#856404' }}>Servicios:</span>
                            <span style={{ color: '#333' }}>
                                {usuarioLegued?.rol === 'coord_programa' || 
                                 usuarioLegued?.rol === 'coord_ceseco' || 
                                 usuarioLegued?.rol === 'secretaria' ||
                                 usuarioLegued?.rol === 'direccion'
                                    ? (serviciosFiltrados.length === servicios.filter(servicio => {
                                        const perteneceACeseco = usuarioLegued?.idCategorias?.includes(servicio.idCategoria) ||
                                                                servicio.idCategoria === usuarioLegued.idCategoria;
                                        if (!perteneceACeseco) return false;
                                        
                                        if (usuarioLegued?.rol === 'coord_ceseco' || usuarioLegued?.rol === 'secretaria') {
                                            return true;
                                        }
                                        
                                        if (usuarioLegued?.rol === 'coord_programa') {
                                            return usuarioLegued?.idServicios?.includes(servicio.idServicio) ||
                                                   usuarioLegued?.idServicio === servicio.idServicio;
                                        }
                                        
                                        return ['admin', 'direccion'].includes(usuarioLegued?.rol);
                                    }).length 
                                        ? 'Todos los servicios' 
                                        : serviciosFiltrados.map(obj => obj.label).join(', '))
                                    : serviciosFiltrados.map(obj => obj.label).join(', ')
                                }
                            </span>
                        </div>
                    )}
                </div>
            )}
            {/* </div> */}
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                onSelectEvent={handleSelectEvent}
                selectable
                views={['month', 'week', 'day', 'agenda']}
                defaultView="month"
                view={currentView}
                onView={setCurrentView}
                popup
                style={{ height: 620 }}
                components={{ event: CustomEvent }}
                messages={{ ...messages, agenda: 'Agenda' }}
                eventPropGetter={(event) => ({ style: event.style })}
                min={new Date(1970, 1, 1, 8, 0, 0)}
            />

            {/* Modal para mostrar los detalles del turno seleccionado */}
            {turnoSeleccionado && (
                <TurnoModal
                    isOpen={modalIsOpen}
                    onClose={handleCloseModal}
                    turnoSeleccionado={turnoSeleccionado}
                    userRole={usuarioLegued?.rol}
                    nombre={nombre}
                    setNombre={setNombre}
                    telefono={telefono}
                    setTelefono={setTelefono}
                    motivoInactivo={motivoInactivo}
                    setMotivoInactivo={setMotivoInactivo}
                    nuevaFecha={nuevaFecha}
                    setNuevaFecha={setNuevaFecha}
                    periodicidad={periodicidad}
                    setPeriodicidad={setPeriodicidad}
                    nuevaHoraInicio={nuevaHoraInicio}
                    setNuevaHoraInicio={setNuevaHoraInicio}
                    nuevaHoraFin={nuevaHoraFin}
                    setNuevaHoraFin={setNuevaHoraFin}
                    nuevoComentario={nuevoComentario}
                    setNuevoComentario={setNuevoComentario}
                    comentarioActualizado={comentarioActualizado}
                    cancelarActualizado={cancelarActualizado}
                    nuevoEstado={nuevoEstado}
                    setNuevoEstado={setNuevoEstado}
                    categorias={categorias}
                    categoriaSeleccionada={categoriaSeleccionada}
                    setCategoriaSeleccionada={setCategoriaSeleccionada}
                    servicioSeleccionado={servicioSeleccionado}
                    setServicioSeleccionado={setServicioSeleccionado}
                    terapeutaSeleccionado={terapeutaSeleccionado}
                    setTerapeutaSeleccionado={setTerapeutaSeleccionado}
                    salaSeleccionada={salaSeleccionada}
                    setSalaSeleccionada={setSalaSeleccionada}
                    citasSeleccionadas={citasSeleccionadas}
                    setCitasSeleccionadas={setCitasSeleccionadas}
                    alertAsignarSala={alertAsignarSala}
                    handleUpdateText={handleUpdateText}
                    handleUpdateDate={handleUpdateDate}
                    handleInsertComment={handleInsertComment}
                    handleCancelar={handleCancelar}
                    sexo={sexo} setSexo={setSexo}
                    escolaridad={escolaridad} setEscolaridad={setEscolaridad}
                    estadoCivil={estadoCivil} setEstadoCivil={setEstadoCivil}
                    ocupacion={ocupacion} setOcupacion={setOcupacion}
                    servicioSalud={servicioSalud} setServicioSalud={setServicioSalud}
                    religion={religion} setReligion={setReligion}
                    municipio={municipio} setMunicipio={setMunicipio}
                    motivoConsulta={motivoConsulta} setMotivoConsulta={setMotivoConsulta}
                    comoEntero={comoEntero} setComoEntero={setComoEntero}
                    catalogoSexo={catalogoSexo} catalogoEscolaridad={catalogoEscolaridad}
                    catalogoEstadoCivil={catalogoEstadoCivil} catalogoServiciosSalud={catalogoServiciosSalud}
                    catalogoReligiones={catalogoReligiones} catalogoMunicipios={catalogoMunicipios}
                    catalogoMotivosConsulta={catalogoMotivosConsulta} catalogoComoEntero={catalogoComoEntero}
                    guardarInfoPaciente={guardarInfoPaciente}
                />
            )}
        </div>
    );
}
